import React, { useEffect } from 'react';
import closeIcon from '../../../../images/svg/close-red.svg';

function GiftCardApplied(props) {
  var _props$cart10, _props$cart10$price;

  var giftCardInfo = props.giftCardInfo,
      removeGiftCard = props.removeGiftCard,
      setGiftCardInfo = props.setGiftCardInfo,
      setPaymentType = props.setPaymentType;
  useEffect(function () {
    var _props$cart, _props$cart$price, _props$cart4, _props$cart4$price, _props$cart7, _props$cart7$price;

    if (((_props$cart = props.cart) === null || _props$cart === void 0 ? void 0 : (_props$cart$price = _props$cart.price) === null || _props$cart$price === void 0 ? void 0 : _props$cart$price.Total) > 0 && (giftCardInfo === null || giftCardInfo === void 0 ? void 0 : giftCardInfo.status) === 'applied-covers') {
      var _props$cart2, _props$cart2$GiftCard, _props$cart3, _props$cart3$GiftCard;

      setGiftCardInfo({
        status: 'applied-not-cover',
        balance: (_props$cart2 = props.cart) === null || _props$cart2 === void 0 ? void 0 : (_props$cart2$GiftCard = _props$cart2.GiftCardDetails) === null || _props$cart2$GiftCard === void 0 ? void 0 : _props$cart2$GiftCard.Balance,
        message: (_props$cart3 = props.cart) === null || _props$cart3 === void 0 ? void 0 : (_props$cart3$GiftCard = _props$cart3.GiftCardDetails) === null || _props$cart3$GiftCard === void 0 ? void 0 : _props$cart3$GiftCard.Message
      });
    }

    if (((_props$cart4 = props.cart) === null || _props$cart4 === void 0 ? void 0 : (_props$cart4$price = _props$cart4.price) === null || _props$cart4$price === void 0 ? void 0 : _props$cart4$price.Total) > 0 && (giftCardInfo === null || giftCardInfo === void 0 ? void 0 : giftCardInfo.status) === 'applied-not-cover') {
      var _props$cart5, _props$cart5$GiftCard, _props$cart6, _props$cart6$GiftCard;

      setGiftCardInfo({
        status: 'applied-not-cover',
        balance: (_props$cart5 = props.cart) === null || _props$cart5 === void 0 ? void 0 : (_props$cart5$GiftCard = _props$cart5.GiftCardDetails) === null || _props$cart5$GiftCard === void 0 ? void 0 : _props$cart5$GiftCard.Balance,
        message: (_props$cart6 = props.cart) === null || _props$cart6 === void 0 ? void 0 : (_props$cart6$GiftCard = _props$cart6.GiftCardDetails) === null || _props$cart6$GiftCard === void 0 ? void 0 : _props$cart6$GiftCard.Message
      });
    }

    if (((_props$cart7 = props.cart) === null || _props$cart7 === void 0 ? void 0 : (_props$cart7$price = _props$cart7.price) === null || _props$cart7$price === void 0 ? void 0 : _props$cart7$price.Total) === 0 && (giftCardInfo === null || giftCardInfo === void 0 ? void 0 : giftCardInfo.status) === 'applied-not-cover') {
      var _props$cart8, _props$cart8$GiftCard, _props$cart9, _props$cart9$GiftCard;

      setGiftCardInfo({
        status: 'applied-covers',
        balance: (_props$cart8 = props.cart) === null || _props$cart8 === void 0 ? void 0 : (_props$cart8$GiftCard = _props$cart8.GiftCardDetails) === null || _props$cart8$GiftCard === void 0 ? void 0 : _props$cart8$GiftCard.Balance,
        message: (_props$cart9 = props.cart) === null || _props$cart9 === void 0 ? void 0 : (_props$cart9$GiftCard = _props$cart9.GiftCardDetails) === null || _props$cart9$GiftCard === void 0 ? void 0 : _props$cart9$GiftCard.Message
      });
    }
  }, [(_props$cart10 = props.cart) === null || _props$cart10 === void 0 ? void 0 : (_props$cart10$price = _props$cart10.price) === null || _props$cart10$price === void 0 ? void 0 : _props$cart10$price.Total]);
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-gift-card-applied ".concat((giftCardInfo === null || giftCardInfo === void 0 ? void 0 : giftCardInfo.status) !== 'error' && (giftCardInfo === null || giftCardInfo === void 0 ? void 0 : giftCardInfo.message) ? 'cb-gift-card-applied--error' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-gift-card-applied__container'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-gift-card-applied__labels'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-gift-card-applied__labels__header'
  }, "Pay with Gift Card"), (giftCardInfo === null || giftCardInfo === void 0 ? void 0 : giftCardInfo.balance) > 1 && /*#__PURE__*/React.createElement("div", {
    className: 'cb-gift-card-applied__labels__balance'
  }, "Balance: $".concat((giftCardInfo === null || giftCardInfo === void 0 ? void 0 : giftCardInfo.balance) ? giftCardInfo === null || giftCardInfo === void 0 ? void 0 : giftCardInfo.balance.toFixed(2) : 0.00))), /*#__PURE__*/React.createElement("div", {
    className: 'cb-gift-card-applied__remove',
    onClick: removeGiftCard
  }, /*#__PURE__*/React.createElement("img", {
    className: 'cb-gift-card-applied__remove__icon',
    src: closeIcon,
    alt: 'remove'
  }))), (giftCardInfo === null || giftCardInfo === void 0 ? void 0 : giftCardInfo.status) !== 'error' && (giftCardInfo === null || giftCardInfo === void 0 ? void 0 : giftCardInfo.message) && /*#__PURE__*/React.createElement("div", {
    className: "is-error cb-gift-card-applied__message"
  }, giftCardInfo === null || giftCardInfo === void 0 ? void 0 : giftCardInfo.message));
}

export default GiftCardApplied;